// extracted by mini-css-extract-plugin
module.exports = {"container":"container___3Tp4m","icon":"icon___-hJH8","oContent":"oContent___3b1Kc","alignContainer":"alignContainer___2_Jxj","alignText":"alignText___3Nf8l"};